class CartAdditionPopup extends HTMLElement {
  constructor() {
    super();
    this.closeBtn = this.querySelector('.cart-addition-popup__close-btn');
    this.overlay = this;
    
    this.close = this.close.bind(this);
    this.handleOverlayClick = this.handleOverlayClick.bind(this);
  }

  connectedCallback() {
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', this.close);
    }
    this.addEventListener('click', this.handleOverlayClick);
    
    document.addEventListener('keyup', (e) => {
      if (e.key === 'Escape' && this.style.display === 'flex') {
        this.close();
      }
    });

    window.addEventListener('pageshow', () => {
      this.close();
    });

    const viewCartBtn = this.querySelector('.cart-addition-popup__view-cart-btn');
    if (viewCartBtn) {
      viewCartBtn.addEventListener('click', () => {
        this.close();
      });
    }
  }

  close() {
    this.style.display = 'none';
    document.body.classList.remove('overflow-hidden');
  }

  handleOverlayClick(e) {
    if (e.target === this) {
      this.close();
    }
  }

  async show(addedItem) {
    this.style.display = 'flex';
    document.body.classList.add('overflow-hidden');

    const imgEl = this.querySelector('.cart-addition-popup__added-image');
    const titleEl = this.querySelector('.cart-addition-popup__added-title');
    const targetNameEl = this.querySelector('.cart-addition-popup__target-name');

    if (addedItem) {
      if (imgEl) {
        if (addedItem.image) {
          imgEl.src = addedItem.image;
          imgEl.alt = addedItem.title || '';
          imgEl.style.display = 'block';
        } else {
          imgEl.style.display = 'none';
        }
      }
      if (titleEl) {

        let variantTitle = '';
        if (addedItem.variant_options && addedItem.variant_options.length > 0) {
          variantTitle = ` - ${addedItem.variant_options.join(' / ')}`;
        } else if (addedItem.variant_title) {
          variantTitle = ` - ${addedItem.variant_title}`;
        }
        
        const fullTitle = addedItem.product_title || addedItem.title;
        if (variantTitle && !fullTitle.includes(variantTitle)) {
          titleEl.textContent = `${fullTitle}${variantTitle}`;
        } else {
          titleEl.textContent = fullTitle;
        }
      }
      if (targetNameEl) {
        targetNameEl.textContent = `"${addedItem.product_title || addedItem.title}"`;
      }
    }

    const listEl = this.querySelector('.cart-addition-popup__recommendations-list');
    if (listEl) {
      listEl.innerHTML = `
        <div class="cart-addition-popup__skeleton-list">
          <div class="cart-addition-popup__skeleton-item">
            <div class="cart-addition-popup__skeleton-image"></div>
            <div class="cart-addition-popup__skeleton-details">
              <div class="cart-addition-popup__skeleton-line title"></div>
              <div class="cart-addition-popup__skeleton-line price"></div>
            </div>
            <div class="cart-addition-popup__skeleton-button"></div>
          </div>
          <div class="cart-addition-popup__skeleton-item">
            <div class="cart-addition-popup__skeleton-image"></div>
            <div class="cart-addition-popup__skeleton-details">
              <div class="cart-addition-popup__skeleton-line title"></div>
              <div class="cart-addition-popup__skeleton-line price"></div>
            </div>
            <div class="cart-addition-popup__skeleton-button"></div>
          </div>
        </div>
      `;
    }

    try {
      const cartResponse = await fetch('/cart.js');
      const cartData = await cartResponse.json();
      
      this.updateFooter(cartData);

      if (addedItem && addedItem.product_id) {
        await this.loadRecommendations(addedItem.product_id, cartData);
      } else {
        if (listEl) {
          listEl.innerHTML = '<div class="cart-addition-popup__empty">No recommendations found.</div>';
        }
      }
    } catch (e) {
      console.error('Error in popup show:', e);
    }
  }

  updateFooter(cartData) {
    const countEl = this.querySelector('.cart-addition-popup__cart-count');
    const totalEl = this.querySelector('.cart-addition-popup__cart-total');

    if (countEl) {
      countEl.textContent = cartData.item_count;
    }
    if (totalEl) {
      totalEl.textContent = this.formatPrice(cartData.total_price);
    }
  }

  async loadRecommendations(productId, cartData) {
    const listEl = this.querySelector('.cart-addition-popup__recommendations-list');
    if (!listEl) return;

    try {
      let response = await fetch(`/recommendations/products.json?product_id=${productId}&intent=complementary&limit=10`);
      let data = response.ok ? await response.json() : { products: [] };
      let products = data.products || [];

      const cartProductIds = cartData.items.map(item => item.product_id);
      
      let filteredProducts = products.filter(product => !cartProductIds.includes(product.id));

      if (filteredProducts.length === 0) {
        response = await fetch(`/recommendations/products.json?product_id=${productId}&intent=related&limit=10`);
        data = response.ok ? await response.json() : { products: [] };
        products = data.products || [];
        filteredProducts = products.filter(product => !cartProductIds.includes(product.id));
      }

      if (filteredProducts.length === 0) {
        listEl.innerHTML = '<div class="cart-addition-popup__empty">No other recommendations available at this time.</div>';
        return;
      }

      this.renderSkeletons(filteredProducts.length, listEl);

      await new Promise(resolve => setTimeout(resolve, 400));

      this.renderRecommendations(filteredProducts, listEl);
    } catch (e) {
      console.error('Error loading recommendations:', e);
      listEl.innerHTML = '<div class="cart-addition-popup__empty">Failed to load recommendations.</div>';
    }
  }

  renderSkeletons(count, container) {
    let skeletonsHtml = '';
    for (let i = 0; i < count; i++) {
      skeletonsHtml += `
        <div class="cart-addition-popup__skeleton-item">
          <div class="cart-addition-popup__skeleton-image"></div>
          <div class="cart-addition-popup__skeleton-details">
            <div class="cart-addition-popup__skeleton-line title"></div>
            <div class="cart-addition-popup__skeleton-line price"></div>
          </div>
          <div class="cart-addition-popup__skeleton-button"></div>
        </div>
      `;
    }
    container.innerHTML = `
      <div class="cart-addition-popup__skeleton-list">
        ${skeletonsHtml}
      </div>
    `;
  }

  renderRecommendations(products, container) {
    container.innerHTML = products.map((product, index) => {
      const image = product.featured_image || 'https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_600x.gif';
      const price = this.formatPrice(product.price);
      
      let priceHtml = `<div class="cart-addition-popup__item-price">${price}</div>`;
      if (product.compare_at_price > product.price) {
        const comparePrice = this.formatPrice(product.compare_at_price);
        priceHtml = `
          <div class="cart-addition-popup__item-price-wrapper">
            <span class="cart-addition-popup__item-compare-price">${comparePrice}</span>
            <span class="cart-addition-popup__item-price sale">${price}</span>
          </div>
        `;
      }

      const hasMultipleVariants = product.variants && product.variants.length > 1 && product.variants[0].title !== 'Default Title';
      let selectHtml = '';
      if (hasMultipleVariants) {
        selectHtml = `
          <div class="cart-addition-popup__select-wrapper">
            <select class="cart-addition-popup__item-select" data-product-index="${index}">
              ${product.variants.map(variant => `
                <option value="${variant.id}" ${variant.available ? '' : 'disabled'}>
                  ${variant.title} ${variant.available ? '' : '(Sold Out)'}
                </option>
              `).join('')}
            </select>
          </div>
        `;
      } else {
        const defaultVariantId = product.variants && product.variants[0] ? product.variants[0].id : product.id;
        selectHtml = `<input type="hidden" class="cart-addition-popup__item-select" data-product-index="${index}" value="${defaultVariantId}">`;
      }

      return `
        <div class="cart-addition-popup__item" data-id="${product.id}">
          <div class="cart-addition-popup__item-image-wrapper">
            <a href="${product.url}">
              <img src="${image}" alt="${this.escapeHtml(product.title)}" class="cart-addition-popup__item-image" loading="lazy">
            </a>
          </div>
          <div class="cart-addition-popup__item-details">
            <a href="${product.url}" class="cart-addition-popup__item-title">${this.escapeHtml(product.title)}</a>
            ${priceHtml}
            ${selectHtml}
          </div>
          <div class="cart-addition-popup__item-actions">
            <button type="button" class="cart-addition-popup__add-btn button button--primary" data-index="${index}">Add to cart</button>
          </div>
        </div>
      `;
    }).join('');

    const addButtons = container.querySelectorAll('.cart-addition-popup__add-btn');
    addButtons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        const idx = e.currentTarget.dataset.index;
        const product = products[idx];
        const itemEl = e.currentTarget.closest('.cart-addition-popup__item');
        const selectEl = itemEl.querySelector('.cart-addition-popup__item-select');
        const variantId = selectEl.value;

        this.addToCart(variantId, e.currentTarget, product);
      });
    });
  }

  async addToCart(variantId, button, product) {
    if (!variantId) return;

    button.disabled = true;
    button.textContent = 'Adding...';
    
    this.isAddingFromPopup = true;

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          sections: ['cart-drawer', 'cart-icon-bubble']
        })
      });

      if (!response.ok) {
        throw new Error('Failed to add recommendation to cart');
      }

      const cartData = await response.json();

      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        // Directly update drawer components
        cartDrawer.getSectionsToRender().forEach((section) => {
          const sectionElement = section.selector
            ? cartDrawer.querySelector(section.selector) || document.querySelector(section.selector)
            : cartDrawer.querySelector(`#${section.id}`) || document.getElementById(section.id);
          if (sectionElement && cartData.sections && cartData.sections[section.id]) {
            sectionElement.innerHTML = cartDrawer.getSectionInnerHTML(cartData.sections[section.id], section.selector);
          }
        });
      }

      try {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'cart-addition-popup',
            productVariantId: variantId,
            cartData: cartData
          });
        }
      } catch (e) {
        console.warn('Pub/Sub event publish failed:', e);
      }

      await this.show(cartData);

    } catch (e) {
      console.error('Error adding recommended product:', e);
      button.disabled = false;
      button.textContent = 'Add to cart';
      alert('Could not add item to cart. Please try again.');
    } finally {
      // Reset flag after a short delay
      setTimeout(() => {
        this.isAddingFromPopup = false;
      }, 500);
    }
  }

  formatPrice(cents) {
    const value = (cents / 100).toFixed(2);
    const parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    
    const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'ZAR';
    
    return `R ${parts.join('.')} ${currency}`;
  }

  escapeHtml(text) {
    if (!text) return '';
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }
}

customElements.define('cart-addition-popup', CartAdditionPopup);
